<template>
  <div class="barChart" ref="barChartContainerDiv">
    <el-table
      :data="outgoingDocs"
      class="style-fullWidth"
      highlight-current-row
      sortable="custom"
      @sort-change="doSort"
      @row-click="viewDetail"
      ref="mainTable"
      :height="tableHeight"
    >
      <el-table-column type="index" fixed></el-table-column>

      <el-table-column fixed width="40">
        <template slot-scope="scope">
          <is-seen-tag :isSeen="scope.row.isSeen"></is-seen-tag>
        </template>
      </el-table-column>

      <el-table-column
        property="quote"
        label="Trích yếu"
        min-width="235"
        sortable
        fixed
      >
        <template slot-scope="scope">
          <break-word-span
            :text="scope.row.quote"
            :maxLength="200"
          ></break-word-span>

          <br/>

          <span v-if="scope.row.docCode"
          >#{{ scope.row.docCode }}&nbsp;&nbsp;</span
          >

          <el-tag v-if="scope.row.docTypeName"
          >{{ scope.row.docTypeName }}
          </el-tag>

          <doc-priority-tag
            :priorityName="scope.row.priorityName"
          ></doc-priority-tag>
        </template>
      </el-table-column>

      <el-table-column
        property="status"
        label="Trạng thái"
        sortable
        v-if="isDisplayField('status')"
        align="center"
        min-width="85"
      >
        <template slot-scope="scope">
          <doc-out-status-tag
            v-if="scope.row.status != null"
            :status="scope.row.status"
          ></doc-out-status-tag>
        </template>
      </el-table-column>

      <el-table-column
        property="senderFullName"
        label="Người chuyển"
        sortable
        v-if="isDisplayField('senderFullName')"
      >
        <template slot-scope="scope">
          <break-word-span
            :text="scope.row.senderFullName"
            :maxLength="100"
          ></break-word-span>
        </template>
      </el-table-column>

      <el-table-column
        property="updateTime"
        label="Thời gian xử lý"
        sortable
        v-if="isDisplayField('updateTime')"
        align="right"
        min-width="100"
      >
        <template slot-scope="scope">
          {{ scope.row.updateTime | dateFormatter({ nullValue: "-" }) }}
        </template>
      </el-table-column>

      <el-table-column
        property="createTime"
        label="Ngày tạo"
        sortable
        v-if="isDisplayField('createTime')"
        align="right"
        min-width="100"
      >
        <template slot-scope="scope">
          {{ scope.row.createTime | dateFormatter({ nullValue: "-" }) }}
        </template>
      </el-table-column>

      <el-table-column
        property="processTime"
        label="Thời gian chuyển"
        sortable
        v-if="isDisplayField('processTime')"
        align="right"
      >
        <template slot-scope="scope">
          {{ scope.row.processTime | dateFormatter({ nullValue: "-" }) }}
        </template>
      </el-table-column>

      <infinite-loading
        slot="append"
        ref="infiniteLoading"
        spinner="spiral"
        @infinite="infiniteHandler"
        force-use-infinite-wrapper=".el-table__body-wrapper"
      >
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>
    </el-table>
  </div>
</template>

<script>
  import dateFormatter from "../../filters/dateFormatter";
  import SortCaret from "./SortCaret";
  import BreakWordSpan from "../adminstration/ketluan/break-word-span";
  import DocOutStatusTag from "./doc-out-status-tag";
  import DocPriorityTag from "../common/doc-priority-tag";
  import infiniteLoading from "vue-infinite-loading";
  import constants from "../../constants";
  import vbOutgoingDocUserViewService from "../../services/vbOutgoingDocUserViewService";
  import utils from "../../services/utils";
  import IsSeenTag from "../common/is-seen-tag";

  export default {
    name: "doc-out-main-content",
    props: ["sort", "order", "advanceSearchForm", "displayFields"],
    components: {
      IsSeenTag,
      DocPriorityTag,
      DocOutStatusTag,
      BreakWordSpan,
      SortCaret,
      infiniteLoading
    },
    filters: {dateFormatter},
    data() {
      return {
        ATTACHMENT_OBJECT_TYPE: constants.ATTACHMENT_OBJECT_TYPE,
        outgoingDocs: [],
        outgoingDocsCount: null,
        page: 0,
        size: 10,
        tableHeight: null,
      };
    },

    mounted(){
      this.tableHeight = window.innerHeight - this.$refs.mainTable.$el.offsetTop - 140;
    },

    methods: {
      isDisplayField(fieldName) {
        return (this.displayFields || []).indexOf(fieldName) !== -1;
      },

      deleteDoc(item) {
        this.$emit("deleteDoc", item);
      },

      doSort(event) {
        let {order, sort} = utils.convertElTableSortEvent(event);
        this.$emit("doSort", {order: order, sort: sort});
      },

      doSearch() {
        this.outgoingDocs = [];
        this.page = 0;
        if (this.$refs.infiniteLoading)
          this.$refs.infiniteLoading.stateChanger.reset();
      },

      list() {
        let pageable = {
          page: this.page,
          size: this.size,
          sort: [this.sort, this.order].join(",")
        };
        let docStatus = !this.advanceSearchForm.docStatus && this.advanceSearchForm.docStatus !== 0
          ? [
            constants.OUTGOING_DOC_STATUS.TAOMOI,
            constants.OUTGOING_DOC_STATUS.DANGXULI,
            constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH,
            constants.OUTGOING_DOC_STATUS.TU_CHOI,
            constants.OUTGOING_DOC_STATUS.TU_CHOI_BAN_HANH
          ]
          : [this.advanceSearchForm.docStatus];
        let relationType;
        switch (this.advanceSearchForm.filterStatus) {
          case constants.DU_THAO_PAGE.FILTER.UY_QUYEN:
            relationType = constants.VB_DOC_USER.RELATION_TYPE.NGUOI_UY_QUYEN;
            break;
          case constants.DU_THAO_PAGE.FILTER.PHOI_HOP:
            relationType = constants.VB_DOC_USER.RELATION_TYPE.NGUOI_PHOI_HOP;
            break;
          default:
            relationType = null;
        }
        let status;
        switch (this.advanceSearchForm.filterStatus) {
          case constants.DU_THAO_PAGE.FILTER.CHO_XU_LY:
            status = constants.DOC_USER_STATUS.CHO_XU_LY;
            break;
          case constants.DU_THAO_PAGE.FILTER.DA_XU_LY:
            status = constants.DOC_USER_STATUS.DA_XU_LY;
            break;
          case constants.DU_THAO_PAGE.FILTER.ALL:
          case constants.DU_THAO_PAGE.FILTER.UY_QUYEN:
          default:
            status = -1;
            break;
        }
        let advanceSearchForm = utils.merge(this.advanceSearchForm, {
          docStatus: docStatus,
          relationType: relationType,
          status: status
        });
        return vbOutgoingDocUserViewService
          .findAll2(advanceSearchForm, pageable)
          .then(response => {
            let items = response.data;
            if (items) {
              const uniqueItems = Object.values(
                items.reduce((acc, item) => {
                  const key = `${item.id}_${item.status}`;
                  if (
                    !acc[key] ||
                    new Date(item.updateTime) > new Date(acc[key].updateTime)
                  ) {
                    acc[key] = item;
                  }
                  return acc;
                }, {})
              );

              this.outgoingDocs.push(...uniqueItems);
              return uniqueItems;
            }

            return [];
          });
      },

      infiniteHandler($state) {
        this.list().then(items => {
          this.page += 1;
          items && items.length ? $state.loaded() : $state.complete();
        });
      },

      isSeen(event) {
        if (event.hasOwnProperty("isSeen")) {
          if (event.isSeen === 1) return "";
          else return "is-seen";
        } else return "";
      },

      viewDetail(item) {
        item.isSeen = 1;
        this.$emit("viewDetail", item);
      }
    }
  };
</script>

<style scoped>
  .barChart {
    /*margin-top: 20px;*/
    height: calc(100% - 100px) !important;
    width: calc(100% - 10px) !important;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/views/doc-out/doc-out-main-content.vue